__turbopack_context__.v({
  "compact-header": "map-bottom-drawer-module-scss-module__wSSBBW__compact-header",
  "drawer-content": "map-bottom-drawer-module-scss-module__wSSBBW__drawer-content",
  "drawer-header-content": "map-bottom-drawer-module-scss-module__wSSBBW__drawer-header-content",
  "empty-state": "map-bottom-drawer-module-scss-module__wSSBBW__empty-state",
  "header-text-section": "map-bottom-drawer-module-scss-module__wSSBBW__header-text-section",
  "listing-card-wrapper": "map-bottom-drawer-module-scss-module__wSSBBW__listing-card-wrapper",
  "listing-cards": "map-bottom-drawer-module-scss-module__wSSBBW__listing-cards",
  "listing-count": "map-bottom-drawer-module-scss-module__wSSBBW__listing-count",
  "load-more-trigger": "map-bottom-drawer-module-scss-module__wSSBBW__load-more-trigger",
  "map-view-button": "map-bottom-drawer-module-scss-module__wSSBBW__map-view-button",
  "more-listings-indicator": "map-bottom-drawer-module-scss-module__wSSBBW__more-listings-indicator",
});
